import { dataShieldUserSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldUserSolid = /*#__PURE__*/createIcon(dataShieldUserSolid)
export default IconShieldUserSolid
